import React, {useEffect, useState} from "react";
import {Button, Dropdown} from "antd";
import ArrowDown from "../../assets/icons/ArrowDown";
import useAppContext from "../../hooks/useAppContext";

interface ConsentPolicySelectorProps {
    consentPolicy: number | null;
    setConsentPolicy: (newVal: number) => void;
    onSelect?: (newVal: number) => void;
    size?: any;
    className?: any;
    type?: 'general' | 'campaign';
    campaignId?: number;
}

const GENERAL_CONSENT_OPTIONS = [
    { key: 0, label: 'Recover all checkouts' },
    { key: 1, label: 'Recover checkouts with general marketing consent' },
    { key: 2, label: 'Recover checkouts with explicit SMS consent only' },
];

const CAMPAIGN_CONSENT_OPTIONS = [
    { key: 0, label: 'All customers' },
    { key: 1, label: 'Customers with general consent' },
    { key: 2, label: 'Customers with specific SMS consent' },
]

const ConsentPolicySelector = ({ consentPolicy, setConsentPolicy, onSelect, size = 'large', className = "", type = "general", campaignId }: ConsentPolicySelectorProps) => {
    const { data: { campaigns, shop }} = useAppContext();

    const getItems = () => {
        if(type === 'campaign') {
            return CAMPAIGN_CONSENT_OPTIONS;
        }
        return GENERAL_CONSENT_OPTIONS;
    }

    const items = getItems();

    useEffect(() => {
        if(type === 'general') {
            setConsentPolicy(shop.data?.consentRule);
        }
        if(type === 'campaign') {
            const campaign = campaigns.data?.find((c: any) => c.id === campaignId);
            campaign?.consentRule !== undefined && campaign?.consentRule !== null && setConsentPolicy(campaign.consentRule);
        }
    }, [shop, campaigns]);

    if(type === 'campaign' && !campaignId) return null;

    return (
        <Dropdown menu={{ items, onClick: (item) => {
            setConsentPolicy(parseInt(item.key))
            onSelect && onSelect(parseInt(item.key));
        } }}>
            <Button style={{ display: 'flex', alignItems: 'center', flexDirection: 'row'}} icon={<div><ArrowDown width={18} height={18} /></div>} type="default" className={className} size={size} loading={consentPolicy === null}>{items.find(item => item.key === consentPolicy)?.label || "Loading shop's consent policies"}</Button>
        </Dropdown>
    );
}

export default ConsentPolicySelector;